import "./Contact.css";
 import { useForm } from "react-hook-form";



const Contact = () => {
    const { register, handleSubmit } = useForm();
     const sendMessage = async (data) =>{
        console.log("sdjhsd")
        const savedUserResponse = await fetch(
            `http://localhost:4000/api/v1/`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ ...data }),
            }
          );
      
          console.log("FORM RESPONSE......", savedUserResponse);
     }
    return (
      
            <div className="contact" id="contact1">
                <h1 data-aos="zoom-in">CONTACT ME</h1>
                <div className="fake5" data-aos="zoom-in"></div>
                <nav>
                    <form className="con-form" action="" onSubmit={handleSubmit(sendMessage)}>
                        <div>
                            <input data-aos="fade-right" type="text" name="name" placeholder="Enter your name " {...register("name")} className="conbox"></input>
                            <input data-aos="fade-left" type="text" name="email" placeholder="Enter your email" {...register("email")} className="conbox"></input>
                        </div>
                        <input data-aos="fade-right" type="text" name="number" placeholder="Enter your Number" {...register("number")} className="num"></input>
                        <textarea data-aos="fade-left" name="message" placeholder="Enter the message" {...register("message")} className="mess" cols="30"
                            rows="10"></textarea>
                        <button data-aos="zoom-in" type="submit">Send message</button>
                    </form>

                    
                </nav>
            </div>
        
    );
}
export default Contact